var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5152 7.53614C20.9027 7.35744 20.9027 6.80668 20.5152 6.62802L16.8552 4.9407C16.7292 4.88245 16.6282 4.78085 16.5701 4.65456L14.8869 0.989809C14.7086 0.601389 14.1566 0.60139 13.9782 0.989811L12.2951 4.65456C12.2369 4.78085 12.1355 4.88245 12.01 4.9407L8.34997 6.62802C7.96243 6.80668 7.96241 7.35744 8.34993 7.53614L12.01 9.22388C12.1355 9.28213 12.2369 9.38368 12.2951 9.50951L13.9782 13.1746C14.1566 13.5631 14.7086 13.5631 14.887 13.1746L16.5701 9.50951C16.6282 9.38368 16.7292 9.28213 16.8552 9.22388L20.5152 7.53614Z",
    fill: "#E6126A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95371 11.9328C8.34122 11.7541 8.3412 11.2033 7.95366 11.0247L6.00132 10.1246C5.92162 10.0878 5.85781 10.0235 5.82104 9.94367L4.92374 7.98997C4.74534 7.60155 4.1934 7.60155 4.015 7.98997L3.1177 9.94367C3.08094 10.0235 3.01683 10.0878 2.93742 10.1246L0.98508 11.0247C0.597544 11.2033 0.597518 11.7541 0.985038 11.9328L2.93742 12.8331C3.01683 12.8699 3.08094 12.9341 3.1177 13.0137L4.01499 14.9676C4.19338 15.3561 4.74536 15.3561 4.92375 14.9676L5.82104 13.0137C5.85781 12.9341 5.92162 12.8699 6.00132 12.8331L7.95371 11.9328Z",
    fill: "#F15A29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5426 22.089C11.9301 21.9103 11.9301 21.3595 11.5425 21.1809L10.9531 20.9092C10.9104 20.8894 10.8762 20.855 10.8565 20.8122L10.5864 20.2241C10.408 19.8357 9.85606 19.8357 9.67767 20.2241L9.40758 20.8122C9.38788 20.855 9.35352 20.8894 9.31096 20.9092L8.72154 21.1809C8.33401 21.3595 8.33398 21.9103 8.7215 22.089L9.31096 22.3608C9.35352 22.3806 9.38788 22.415 9.40758 22.4576L9.67766 23.0457C9.85605 23.4342 10.408 23.4342 10.5864 23.0457L10.8565 22.4576C10.8762 22.415 10.9104 22.3806 10.9531 22.3608L11.5426 22.089Z",
    fill: "#005E9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.71993,
    cy: 20.4025,
    r: 0.937294,
    transform: "rotate(-180 1.71993 20.4025)",
    fill: "#3EB5E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.216,
    cy: 15.2775,
    r: 0.937294,
    transform: "rotate(-180 19.216 15.2775)",
    fill: "#143860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsSmall);
export default __webpack_public_path__ + "static/media/stars-small.e2995bcbcaf143219e697b2c8f119e6d.svg";
export { ForwardRef as ReactComponent };